export default __webpack_public_path__ + "static/media/ppnTherapist5.aa6422da.jpg";